import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

import App from './App';
import { Auth0Provider } from "@auth0/auth0-react";
//import reportWebVitals from './reportWebVitals';

//{window.location.origin}

var _AUTH0_CONFIG = {
  domain:"dev-wush4mixt8nevomp.us.auth0.com",
  clientId:"bV0KqE3BBwJwA9MjiVuzH5TpAm2EHWEF",
  redirectUri:"http://localhost:3000/loggedin",
  audience:'https://dev-api.binderdrop.com/',
  scope:"brokers:read",

};

var _redirectURL = window.location.hostname.indexOf('localhost') > -1 ? 'http://localhost:3000/loggedin' : 'https://dev-binderdrop.azurewebsites.net/loggedin';

var _page =  <Auth0Provider
    domain="dev-wush4mixt8nevomp.us.auth0.com"
    clientId="bV0KqE3BBwJwA9MjiVuzH5TpAm2EHWEF"
    redirectUri={_redirectURL}
    audience="https://dev-wush4mixt8nevomp.us.auth0.com/api/v2/"
    scope="read:current_user update:current_user_metadata"
  >
  <React.StrictMode><App /></React.StrictMode>
  </Auth0Provider>;

ReactDOM.render(_page,document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
